import { useState } from "react";
import { useConfig } from "../../api/queries";
import { CenteredSpinner } from "../CenteredSpinner";
import { TransactionFormContent } from "./TransactionFormContent";

export const TransactionForm = () => {
  const { data: config, isLoading: configLoading } = useConfig();
  const [formKey, setFormKey] = useState(0);

  if (configLoading || !config) {
    return <CenteredSpinner padding={2} />;
  }

  return (
    <TransactionFormContent
      key={formKey}
      config={config}
      defaults={config.manualTransactionDefaults}
      onSuccess={() => setFormKey((prev) => prev + 1)}
    />
  );
};
